module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/00a42ec539deb373d4d933a249b1dae7.png";